import React from "react";
import DefaultButton from "../default-button/DefaultButton";
import Plus from "../../assets/icons/Plus";
import Edit from "../../assets/icons/Edit";
import Delete from "../../assets/icons/Delete";
import { useHookstate } from "@hookstate/core";
import { useUniversalFind, useUniversalFindAll } from "../../hooks/universal";
import {
  onInputChangeNative,
  showSnackbar,
  updateLocalStateRaw,
} from "../../misc/utils";
import { simpleGetter } from "../../actions/common";
import { demeritsApi } from "../../api/api";
import InputField from "../input-field/InputField";
import Modal from "../Modal/Modal";
import ArrowLeft from "../../assets/icons/ArrowLeft";
import Tick from "../../assets/icons/Tick";

const DisciplinarySpecies = () => {
  const model = "DemeritType";
  const localState = useHookstate({});
  const state: Record<string, any> = localState.get();
  const search = state.search || "";
  const categoryName = state.categoryName || "";
  const commonDemeritTypeId = state.commonDemeritTypeId || "";
  const currentCategory = state.currentCategory || {};
  const addModalOpen = Boolean(state.addModalOpen);
  const categoriesTriggerFetch = state.categoriesTriggerFetch || 0;
  const allCategories: any[] = useUniversalFind(
    "DemeritType",
    {},
    {
      include: ["common_demerit_type", "demerits"],
    },
    categoriesTriggerFetch
  );
  const commonDemeritTypes: any[] = useUniversalFindAll("CommonDemeritType");
  const categories = allCategories.filter((c) => {
    return c.name?.toLowerCase().includes(search.toLowerCase());
  });

  const toggleModal = () => {
    updateLocalStateRaw(localState, "addModalOpen")(!addModalOpen);
  };

  const openModal = (mode: string, current?: any) => () => {
    if (mode === "add") {
      updateLocalStateRaw(localState, "currentCategory")(null);
      updateLocalStateRaw(localState, "categoryName")("");
    } else {
      updateLocalStateRaw(localState, "currentCategory")(current);
      updateLocalStateRaw(localState, "categoryName")(current.name);
      updateLocalStateRaw(
        localState,
        "commonDemeritTypeId"
      )(current.common_demerit_type_id);
    }
    toggleModal();
  };

  const submit = async () => {
    const body = {
      model,
      create: {
        name: categoryName,
        common_demerit_type_id: commonDemeritTypeId,
      },
    };
    if (currentCategory.id) {
      //@ts-ignore
      body.create.id = currentCategory.id;
    }
    const response = await simpleGetter(demeritsApi.upsertDemeritType, body);
    showSnackbar(
      response.success ? "Успешно" : "Произошла ошибка",
      response.success ? "success" : "error"
    );
    if (response.success) {
      updateLocalStateRaw(
        localState,
        "categoriesTriggerFetch"
      )(categoriesTriggerFetch + 1);
      toggleModal();
    }
  };

  const deleteDemeritType = (id: number) => async () => {
    const response = await simpleGetter(demeritsApi.deleteDemeritType, id);
    showSnackbar(
      response.success ? "Успешно" : "Произошла ошибка",
      response.success ? "success" : "error"
    );
    if (response.success) {
      updateLocalStateRaw(
        localState,
        "categoriesTriggerFetch"
      )(categoriesTriggerFetch + 1);
    }
  };

  return (
    <div className='flex flex-col flex-1 gap-4 bg-white rounded-xl p-6'>
      <div className='flex flex-row items-center'>
        <InputField
          type='text'
          placeholder='Поиск'
          value={search}
          handleChange={onInputChangeNative(localState, "search")}
          wrapperClassName='flex-1'
          additionalClassName='rounded-lg py-3 px-4 bg-valley-background-blue'
        />
        <div className='flex flex-row flex-[3] justify-end items-center'>
          <DefaultButton
            Icon={Plus}
            buttonText='Создать вид нарушения'
            additionalStyle='border border-green-500 text-green-500 px-3 py-2 text-sm font-semibold'
            onClick={openModal("add")}
          />
        </div>
      </div>
      <div className='flex flex-col overflow-auto'>
        <table className='w-full border-collapse mt-4 rounded-lg overflow-hidden'>
          <thead>
            <tr className='border-b border-gray-200 bg-white-500 '>
              <th className='px-4 py-3 border-b text-left text-gray-500'>
                Название нарушения
              </th>
              <th className='px-4 py-3 border-b text-left text-gray-500'>
                Тип нарушения
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {categories.map((c) => (
              <tr className='border-b border-gray-200 bg-white-500'>
                <td className='px-4 py-2 bg-white'>{c.name}</td>
                <td className='px-4 py-2 bg-white'>
                  {c.common_demerit_type?.name}
                </td>
                <td className='px-4 py-3 bg-white'>
                  <div className='flex justify-end gap-4'>
                    <DefaultButton
                      Icon={Edit}
                      buttonText='Редактировать'
                      additionalStyle='px-3 border border-gray-300 text-gray-600 hover:bg-gray-100 '
                      onClick={openModal("edit", c)}
                    />
                    {!c.demerits.length && (
                      <DefaultButton
                        Icon={Delete}
                        buttonText='Удалить'
                        additionalStyle='px-3 border border-red-500 text-red-500 hover:bg-red-100'
                        onClick={deleteDemeritType(c.id)}
                      />
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Modal
        visible={addModalOpen}
        setVisible={updateLocalStateRaw(localState, "addModalOpen")}
        additionalClassName='p-8 w-[32.5%]'
      >
        <div className='flex flex-col gap-8'>
          <span className='text-2xl leading-[26.4px] text-valley-black'>
            Название вида нарушения
          </span>
          <InputField
            type='textarea'
            id='category-name'
            label='Название вида нарушения'
            handleChange={onInputChangeNative(localState, "categoryName")}
            value={categoryName}
            additionalClassName='bg-valley-background-blue py-3 px-4 rounded-lg'
          />
          <div className='flex flex-col'>
            <InputField
              type='select'
              id='select-demerit-type'
              label='Тип нарушения'
              value={commonDemeritTypeId}
              handleChange={onInputChangeNative(
                localState,
                "commonDemeritTypeId"
              )}
              options={commonDemeritTypes.map((d) => ({
                value: d.id,
                label: d.name,
              }))}
              additionalClassName='bg-valley-background-blue py-3 px-4 rounded-lg'
            />
          </div>
          <div className='flex-1 flex flex-row gap-3'>
            <DefaultButton
              buttonText='Вернуться'
              additionalStyle='flex-1 bg-[#5F6B88] text-white px-8 py-3 text-nowrap'
              Icon={ArrowLeft}
              onClick={toggleModal}
            />
            <DefaultButton
              buttonText='Сохранить'
              additionalStyle='flex-1 bg-valley-dark-green text-white px-8 py-3 text-nowrap'
              Icon={Tick}
              onClick={submit}
              disabled={!(categoryName.length && commonDemeritTypeId)}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default DisciplinarySpecies;
